import { combineReducers } from 'redux';

import payment from './payment';
import shop from './shop';
import payMethods from './payMethods';
import payWays from './payWays';
import cache from './cache';
import infos from './infos';
import invoice from './invoice';

export default combineReducers({
  payment,
  shop,
  payMethods,
  payWays,
  cache,
  infos,
  invoice,
});
